export var SPOTLIGHT_SITE_SELECTOR_TARGET = 'rovo-chat-site-selector';